<template>
  <div class="episodes">
    <button class="secondary" @click="$router.push('/shows/' + name)">back</button>
    <h1>{{name}} - {{season}}</h1>

    <table>
      <thead>
        <th>Name</th>
      </thead>
      <tbody>
        <tr v-for="episode in episodes" :key="episode.id" :class="lastVideo == episode.fileId ? 'last-watched' : watchedVideos.includes(episode.fileId.toString()) ? 'watched' : ''">
          <td @click="$router.push('/watch/' + episode.fileId)"><span>{{episode.name}}</span> <span v-if="lastVideo == episode.fileId">(last watched)</span></td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>

import config from '../config';

const token =  localStorage.getItem('token');

export default {
  name: 'Episodes',
  props: {
    session: Object
  },
  data() {
    return {
      episodes: [],
      lastVideo: this.session.lastVideoId,
      name: '',
      season: '',
      watchedVideos: []
    }
  },
  methods: {
    getEpisodes() {
      const { name, season } = this.$route.params;

      this.name = name;
      this.season = season;

      this.axios.get(config.api + `/episodes/${name}/${season}`, {
        headers: {
          'authorization': token
        }
      })
        .then(result => {
          this.episodes = result.data;
        })
        .then(() => {
          if (this.$route.query.next) {
            const lastIndex = this.episodes.map(episode => episode.fileId).indexOf(this.session.lastVideoId);

            if (lastIndex !== -1 && lastIndex <= this.episodes.length - 2) {
              this.$router.push('/watch/' + this.episodes[lastIndex + 1].fileId)
            }
          }
        })
    }
  },
  created() {
    this.getEpisodes();

    this.watchedVideos = JSON.parse(this.session.watchedVideos);
  }
}
</script>

<style scoped>

.last-watched > td > span {
  color: rgb(147, 197, 147);
}

.watched > td > span {
  color: grey;
}

button.secondary {
  margin: 20px 0 -10px 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Episodes.vue